import logoDark from "@assets/Logo_Dark_1777741975086.png";
import logoLight from "@assets/Logo_Light_1777741975086.png";

const NATURAL_W = 3431;
const NATURAL_H = 557;
const RATIO = NATURAL_W / NATURAL_H;

interface LogoProps {
  height?: number;
  className?: string;
  testId?: string;
  title?: string;
  /**
   * "dark" wordmark is for light backgrounds (default).
   * "light" wordmark is for dark backgrounds.
   */
  variant?: "dark" | "light";
  /**
   * When true, the image is marked aria-hidden and carries no accessible name.
   * Use when the wrapping element (e.g. a <Link aria-label="...">) already
   * provides one.
   */
  decorative?: boolean;
}

export function Logo({
  height = 28,
  className = "",
  testId = "logo-wordmark",
  title = "LeadSweet",
  variant = "dark",
  decorative = false,
}: LogoProps) {
  const width = Math.round(height * RATIO);
  const src = variant === "light" ? logoLight : logoDark;
  return (
    <img
      src={src}
      alt={decorative ? "" : title}
      aria-hidden={decorative ? true : undefined}
      data-testid={testId}
      width={width}
      height={height}
      className={className}
      /*
       * Ancho EXPLICITO, no "auto".
       *
       * Con `width: auto` basta con meter el logo en un contenedor flex en
       * columna para que se deforme: el `align-items: stretch` que traen por
       * defecto estira al hijo en el eje transversal —que ahi es el ancho— y,
       * como la altura esta fijada, la proporcion se va. Es lo que le pasaba en
       * el pie de marketing (.ls-footer-x-brand): salia a 4.0 en vez de a 6.16,
       * estirado en pantalla ancha y aplastado en movil.
       *
       * Un ancho definido gana al stretch, asi que el componente queda a salvo
       * de donde se le ponga. Y la altura pasa a `auto`: si el hueco es mas
       * estrecho que el logo, `maxWidth` recorta el ancho y la altura le sigue
       * sola, encogiendo en proporcion en vez de dejar caja vacia debajo. La
       * altura que se pide por prop es entonces la que sale cuando hay sitio,
       * que es el caso normal.
       */
      style={{ display: "block", width, height: "auto", maxWidth: "100%" }}
      draggable={false}
    />
  );
}
